// core
import React, { useState, useEffect, useRef, useContext, ReactElement } from "react";

export const DimmedContext = React.createContext<{
    setState: React.Dispatch<React.SetStateAction<boolean>>;
}>({
    setState: (): void => undefined
});

const PageBlurProvider: React.FC = (props) => {
    const [isDimmed, setIsDimmed] = useState(false);
    const ref = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (ref.current) {
            ref.current.style.background = isDimmed ? "rgba(16,20,0,0.7)" : "";
        }
    }, [isDimmed]);

    return (
        <DimmedContext.Provider value={{ setState: setIsDimmed }}>
            <div ref={ref} style={{ minHeight: "100%" }}>
                {props.children}
            </div>
        </DimmedContext.Provider>
    );
};

export const DimPage = (): ReactElement | null => {
    const context = useContext(DimmedContext);
    useEffect(() => {
        context.setState(true);
        return (): void => {
            context.setState(false);
        };
    }, [context]);
    return null;
};

export default PageBlurProvider;
